/**
 * @desc 沃尔玛库存导出
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  params: API.fulfilment.stockSkuPlatform.walmartStockExport.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/stock/platform/walmartStockExport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
